import { render, staticRenderFns } from "./Deallist.vue?vue&type=template&id=566e35f0&scoped=true"
import script from "./Deallist.vue?vue&type=script&lang=js"
export * from "./Deallist.vue?vue&type=script&lang=js"
import style0 from "./Deallist.vue?vue&type=style&index=0&id=566e35f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566e35f0",
  null
  
)

export default component.exports